export const noticeboardApi = {
    getAdminNotice:'v1/api/notice/agent', 
    getAdminNoticeByPublish:'v1/api/notice', 
    getMainAdminNotice:'v1/api/notice', 
    deleteNotice:'v1/api/notice',
    createAdminNotice : 'v1/api/notice',
    getNoticeByID:'v1/api/notice',
    getNoticeByIDAdmin:'v1/api/notice/agent',
    getMainAdminNoticeByID:'v1/api/notice',
    updateNotice:'v1/api/notice',
    seenNotice:'v1/api/notice/userGroup',
    getById:'v1/api/notice/getById',
    noticeSeenAdmin:'v1/api/notice/seen/admin',
    getNotification:'v1/api/notice/notification',
    updateNotification:'v1/api/notice/seen/agent',
    showAgentNotification:'v1/api/notice/changePopUpStatus',
    getUserGroupJobRole:'v1/api/jobrole',
    uploadBirthDayDoc:'v1/api/notice/uploadNoticeImage',
    getNoticeBirthDayPopup: 'v1/api/notice?userType=admin',
    getNoticeMarkAsRead: 'v1/api/notice/seen/admin',
}
